module.exports = __webpack_public_path__ + "static/media/shopping.e51e980e.png";